import React from "react";
import classes from "./ComingSoon.module.css";

const ComingSoon = () => {
    return (
        <div className={classes.mainCont}>
            <h2>Dostępne wkrótce!</h2>
        </div>
    )
};

export default ComingSoon;